import { useLocation, Link } from "react-router-dom";
import { Building2, ChevronRight, LogOut } from "lucide-react";

import { cn } from "@/lib/utils";
import { useLogout } from "@/hooks/use-auth";
import { useAuth } from "@/contexts/AuthContext";
import { ACCOUNT_SECTIONS, isSectionActive } from "./account-sections";

/** Desktop-only cabinet sidebar; phones get AccountSectionNav and logout in the header menu. */
export function AccountSidebar() {
  const location = useLocation();
  const currentPath = location.pathname;
  const { user } = useAuth();
  const { mutate: logout, isPending: isLoggingOut } = useLogout();

  return (
    <aside className="section-block flex w-full shrink-0 flex-col overflow-hidden md:min-h-[calc(100dvh-12rem)] md:w-64">
      {/* Profile summary */}
      <div className="border-b border-border bg-secondary/70 p-6">
        <div className="flex items-center gap-3">
          <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center">
            <Building2 className="size-6 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-medium text-foreground truncate">
              {user?.name || user?.email || "Личный кабинет"}
            </p>
            <p className="text-sm text-muted-foreground truncate">{user?.email ?? ""}</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="p-4 flex-1">
        <ul className="space-y-1">
          {ACCOUNT_SECTIONS.map((item) => {
            const isActive = isSectionActive(item.path, currentPath);

            return (
              <li key={item.id}>
                <Link
                  to={item.path}
                  aria-current={isActive ? "page" : undefined}
                  className={cn(
                    "flex items-center gap-3 rounded-md px-4 py-3 text-sm font-medium transition-colors",
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "text-muted-foreground hover:bg-secondary hover:text-foreground",
                  )}
                >
                  <item.icon className="size-5" />
                  <span className="flex-1">{item.label}</span>
                  {isActive && <ChevronRight className="size-4" />}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Logout */}
      <div className="border-t border-border bg-secondary/40 p-4">
        <button
          onClick={() => logout()}
          disabled={isLoggingOut}
          className="flex w-full items-center gap-3 rounded-md px-4 py-3 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground disabled:opacity-50"
        >
          <LogOut className="size-5" />
          <span>{isLoggingOut ? "Выход..." : "Выйти"}</span>
        </button>
      </div>
    </aside>
  );
}
